module.exports = __webpack_public_path__ + "static/media/Slide07.b87c0c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide07.png
// module id = 1629
// module chunks = 0